// Claude: Admin Stats page — platform-wide meeting counts 27-02-2026
import { Box, Flex, Text } from "@chakra-ui/react";
import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { DashboardAPI } from "../../Apis/dashboardApi";
import Loader from "../../Components/Loader/Loader";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { errorHandler } from "../../Utils/handler";

type Props = {};

const Stats = (props: Props) => {
  const { error } = useToastWrapper();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<any>(null);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await DashboardAPI.getMeetingStats();
      setStats(res?.data);
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { getData(); }, []);

  const rows = stats
    ? [
        { key: "open", status: "Open", count: stats.open },
        { key: "confirmed", status: "Confirmed", count: stats.confirmed },
        { key: "closed", status: "Closed", count: stats.closed },
        { key: "cancelledExpired", status: "Cancelled / Expired", count: stats.cancelledExpired },
        { key: "incomplete", status: "Incomplete", count: stats.incomplete },
        { key: "total", status: "Total", count: stats.total, bold: true },
      ]
    : [];

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (v: string, rec: any) =>
        rec.bold ? <strong>{v}</strong> : v,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      render: (v: number, rec: any) =>
        rec.bold ? <strong>{v}</strong> : v,
    },
  ];

  return (
    <div className="p-4">
      {loading ? <Loader /> : null}

      <Flex alignItems="center" gap={2} mt={2} mb={4}>
        <Text fontSize="md" fontWeight={600}>Meeting Stats</Text>
      </Flex>

      <Box
        maxW="400px"
        sx={{ "& .ant-table": { fontSize: "12px" }, "& .ant-table-cell": { fontSize: "12px" } }}
      >
        <Table
          size="small"
          style={{ width: "100%" }}
          tableLayout="fixed"
          dataSource={rows}
          columns={columns}
          bordered
          pagination={false}
          rowKey="key"
        />
      </Box>
    </div>
  );
};

export default Stats;
